import React from 'react';
import { Box, Heading, Text, Button, VStack, Icon } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaTools } from 'react-icons/fa';

const MotionBox = motion(Box);

const Maintenance = () => {
    return (
        <Box
            minH="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgGradient="linear(to-br, blue.50, white, blue.50)"
            px={4}
            overflow="hidden"
        >
            <MotionBox
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                p={10}
                bg="rgba(255, 255, 255, 0.6)"
                backdropFilter="blur(20px)"
                rounded="3xl"
                shadow="2xl"
                maxW="xl"
                textAlign="center"
                border="1px solid"
                borderColor="whiteAlpha.500"
                position="relative"
                zIndex={1}
            >
                {/* Decorative background blobs */}
                <Box
                    position="absolute"
                    top="-50px"
                    left="-50px"
                    w="150px"
                    h="150px"
                    bg="blue.200"
                    filter="blur(60px)"
                    opacity="0.6"
                    zIndex="-1"
                />
                <Box
                    position="absolute"
                    bottom="-50px"
                    right="-50px"
                    w="150px"
                    h="150px"
                    bg="purple.200"
                    filter="blur(60px)"
                    opacity="0.6"
                    zIndex="-1"
                />

                <VStack spacing={8}>
                    <Box
                        p={4}
                        bg="blue.50"
                        rounded="full"
                        color="blue.500"
                        shadow="inner"
                    >
                        <Icon as={FaTools} w={12} h={12} />
                    </Box>

                    <VStack spacing={3}>
                        <Heading as="h1" size="2xl" color="gray.800" fontWeight="bold">
                            We'll be back soon!
                        </Heading>
                        <Text fontSize="xl" color="gray.600" maxW="md">
                            Our website is currently undergoing scheduled maintenance.
                            We should be back shortly.
                        </Text>
                    </VStack>

                    <Button
                        colorScheme="blue"
                        size="lg"
                        rounded="full"
                        px={10}
                        height="56px"
                        fontSize="lg"
                        shadow="lg"
                        _hover={{ transform: 'translateY(-2px)', shadow: 'xl' }}
                        transition="all 0.2s"
                        onClick={() => window.location.reload()}
                    >
                        Refresh Page
                    </Button>
                </VStack>
            </MotionBox>
        </Box>
    );
};

export default Maintenance;
